import { IRouteConfig, ROUTES } from '@/models/router.model';
import {
  AdminsList,
  Home,
  Orders,
  Profile,
  Properties,
  PropertiesSold,
  RequiredDocuments,
  Settings,
  Users,
} from '@/pages';

export const routesConfig: IRouteConfig[] = [
  {
    title: 'Home',
    path: ROUTES.HOME,
    component: <Home />,
  },
  {
    title: 'Required Documents',
    path: ROUTES.REQUIRED_DOCUMENTS,
    component: <RequiredDocuments />,
  },
  {
    title: 'Admins list',
    path: ROUTES.ADMINS,
    component: <AdminsList />,
  },
  {
    title: 'Users list',
    path: ROUTES.USERS,
    component: <Users />,
  },
  {
    title: 'Orders list',
    path: ROUTES.ORDERS,
    component: <Orders />,
  },
  {
    title: 'Properties In Progress',
    path: ROUTES.PROPERTIES,
    component: <Properties />,
  },
  {
    title: 'Properties Sold',
    path: ROUTES.PROPERTIES_SOLD,
    component: <PropertiesSold />,
  },
  {
    title: 'Settings',
    path: ROUTES.SETTINGS,
    component: <Settings />,
  },
  {
    title: 'Profile',
    path: ROUTES.PROFILE,
    component: <Profile />,
  },
];
